import {Component, Input, OnInit} from '@angular/core';
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {Router} from "@angular/router";

interface IFeature {
  icon?: string;
  text?: string;
  iconColor: string;
}

interface IButton {
  color: string;
  size: string;
  text: string;
  class?: string;
}

@Component({
    selector: 'db-informative-dialog',
    templateUrl: './informative-dialog.component.html',
    styleUrls: ['./informative-dialog.component.scss'],
    standalone: false
})
export class InformativeDialogComponent implements OnInit {

  @Input() button: IButton;
  @Input() title?: string;
  @Input() eventAction?: string;
  @Input() eventLabel?: string;
  @Input() description?: string;
  @Input() features?: IFeature[];
  @Input() rightImage?: string;
  @Input() sizes?: { width: number, height: number };
  @Input() websiteId?: number;

  constructor(
    private readonly _activateModal: DbActiveModal,
    private readonly _router: Router,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) {
  }

  ngOnInit() {
    if (this.sizes) {
      this._activateModal.resize(this.sizes.height, this.sizes.width);
    }
    this._onModalInitEvent();
  }

  private _onModalInitEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Pageview',
      eventAction: this.eventAction,
      eventLabel: this.eventLabel,
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  public close() {
    this._activateModal.close();
  }

}
